import { render, staticRenderFns } from "./AppVehiclesGroup.vue?vue&type=template&id=e28b61a6&"
import script from "./AppVehiclesGroup.vue?vue&type=script&lang=js&"
export * from "./AppVehiclesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports